import React, { Component } from "react";
import "./roles-management-description.css";
import { Modal } from "react-bootstrap";
import AppContext from "../../appContext";
import { CATEGORIES, IMAGE_PATHS, isLabIndependente, ROLES } from "../../shared/constants/rolesCategories";

class RolesManagementDescription extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false
		};
		RolesManagementDescription.contextType = AppContext;
	}

	handleShow = () => this.setState({ showModal: true });
	handleClose = () => this.setState({ showModal: false });

	getImagePath = () => {
		const categoria = this.context.userSession.papelCategoria;
		const papel = this.context.userSession.papel;

		switch (categoria) {
			case CATEGORIES.LABORATORIO:
				if (isLabIndependente(papel)) {
					return IMAGE_PATHS.LAB_INDEPENDENTE;
				}
				return IMAGE_PATHS.LABORATORIO;
			case CATEGORIES.LAB_INDEPENDENTE:
				return IMAGE_PATHS.LAB_INDEPENDENTE;
			case CATEGORIES.OTICA:
				return IMAGE_PATHS.OTICA;
			case CATEGORIES.ESSILOR:
				return IMAGE_PATHS.ESSILOR;
			default:
				return IMAGE_PATHS.ESSILOR;
		}
	};

	render() {
		const { showModal } = this.state;

		const gestaoPapeis = () => {
			const papel = this.context.userSession.papel;
			const categoria = this.context.userSession.papelCategoria;

			if (categoria === CATEGORIES.OTICA ||
				categoria === CATEGORIES.MEDICO ||
				categoria === CATEGORIES.LABORATORIO ||
				categoria === CATEGORIES.LAB_INDEPENDENTE
			) {
				if (papel === ROLES.CONSULTOR_LABORATORIO) {
					return (
						<>
							<span>Consulte clientes pelo CPF, E-mail ou CNPJ da empresa a qual estão vinculados.</span>
							<br/>
							<span>
                Consulte o <em>mapeamento de permissões</em>{ " " }
								<a id="roles-description-profiles-modules-consultant-link" href="#" onClick={ (e) => {
									e.preventDefault();
									this.handleShow();
								} } className="perfis-modulos-link">
                  Perfis x Módulos
                </a>.
              </span>
						</>
					);
				}
				return (
					<>
						<span>Confira quais são os demais usuários do Essilor Conecta vinculados à sua empresa.</span>
						<br></br>
						<span>A gestão e manutenção dos usuários abaixo são de sua responsabilidade.</span>
						<br/>
						<span>
              Consulte o <em>mapeamento de permissões</em>{ " " }
							<a id="roles-description-profiles-modules-owner-link" href="#" onClick={ (e) => {
								e.preventDefault();
								this.handleShow();
							} } className="perfis-modulos-link">
                Perfis x Módulos
              </a>.
            </span>
					</>
				);
			} else if (categoria === CATEGORIES.ESSILOR) {
				return (
					<>
						<span>Consulte colaboradores pelo CPF, E-mail ou CNPJ da empresa a qual estão vinculados.</span>
						<br/>
						<span>
              Consulte o <em>mapeamento de permissões</em>{ " " }
							<a id="roles-description-profiles-modules-essilor-link" href="#" onClick={ (e) => {
								e.preventDefault();
								this.handleShow();
							} } className="perfis-modulos-link">
                Perfis x Módulos
              </a>.
            </span>
					</>
				);
			}
		};

		return (
			<>
				<div className="x-user-consultant__left">
					<h1 className="x-user-consultant__title">Gestão de Papéis</h1>
					<span className="x-user-consultant__shape"></span>
					<p className="x-user-consultant__paragraph">
						{ gestaoPapeis() }
					</p>
				</div>

				<Modal
					show={ showModal }
					onHide={ this.handleClose }
					size="lg"
					centered
					dialogClassName="image-modal">
					<Modal.Header closeButton className="border-0 pb-0">
					</Modal.Header>
					<Modal.Body className="p-0">
						<img
							src={ this.getImagePath() }
							alt="Mapeamento Perfis x Módulos"
							className="w-100"
							style={ { display: 'block' } }
						/>
					</Modal.Body>
				</Modal>
			</>
		);
	}
}

export default RolesManagementDescription;